export default __webpack_public_path__ + "static/funnel-steps-breakdown-dark-mode-a0bdb503d9c109463a24ac8c78896aa1.png";